import { name, version } from './package.json';
import { injectStyle } from '@edicom/common/tool/injectStyle';
import { ID_SKIN, ID_DENSITY, ID_SKIN_DEFAULT, ID_DENSITY_DEFAULT, ID_STYLE, DENSITIES } from './src/javascript/constants';
import { setVersionInEdicom } from '@edicom/common/edicom/setVersionInEdicom';
import { themeApi } from './src/javascript/themeApi';
import { initDirectives } from './src/javascript/initDirectives';

/**
 * Import css
 */
import cssVariables from './dist/variables.css';
import cssColors from './dist/colors.css';
import style from './index.css';

const edicomDesign = document.documentElement.getAttribute('edicom-design') ?? 'smartadmin';
// const cssDensity =

/**
 * Injección de css
 * insertamos los <style>, el orden importa para las variables de skin y colores:
 */
injectStyle(`/* aqui va el modo personalizado (variables) si se añade por la directiva edicom-theme-density */\n${DENSITIES[edicomDesign].default}`, ID_DENSITY, {
  insertBefore: true,
  overwrite: false,
});
injectStyle('/* aqui va el tema personalizado (colores) si se añade por la directiva edicom-theme-skin */', ID_SKIN, { insertBefore: true, overwrite: false });
injectStyle(cssVariables, ID_DENSITY_DEFAULT, { insertBefore: true, overwrite: false });
injectStyle(cssColors, ID_SKIN_DEFAULT, { insertBefore: true, overwrite: false });
injectStyle(style, ID_STYLE, { overwrite: false });

/**
 * set version @edicom/theme
 */
setVersionInEdicom(name, version);

/**
 * RTL Right to left - si undefined añadimos el atributo <html dir="ltr">
 */
if (!document.documentElement.hasAttribute('dir')) {
  document.documentElement.setAttribute('dir', 'ltr');
}

/**
 * create api
 */
globalThis.edicom = globalThis.edicom || {};
globalThis.edicom.theme = themeApi;

/**
 * handles directives
 */
initDirectives();
